import { DpProductSubcategoriesSwitcherModel } from '../models';
import { ProductSubcategories } from '../types';


export const DP_PRODUCT_CATEGORIES_FEATURE = 'dpProductCategoriesFeature';

export type ProductSubcategoriesState = {
  categories?: ProductSubcategories;
  switcher: DpProductSubcategoriesSwitcherModel;
};
